import { styled } from 'styled-components';

export const MobileContainer = styled.div`
padding: 20px;;
`;


export const MobileBox = styled.div`
  padding: 20px;

  & > ul {
    & > li > a {
      color: #000000;
      font-size: 20px;
      font-family: 'Playfair Display', sans-serif;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      text-decoration: none;
      position: relative;
      display: inline-block;
      transition: all 150ms linear;

      margin-bottom: 15px;

      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 0;
        height: 2px;
        background-color: #000;
        transition: width 0.3s ease;
      }

      &:hover::after,
      &:focus::after {
        width: 100%;
      }
    }
  }
`;

export const MobileMenuBox = styled.div`
  position: fixed;
  top: 0px;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  transform: translateX(100%);
  transition: transform 250ms ease-in-out;
  display: flex;
  flex-direction: column;
  background-color: #faf5ef;

  &.is-expanded {
    transform: translateX(0);
  }

  @media screen and (min-width: 1281px) {
    display: none;
  }
`;

export const HeaderSvgMobile = styled.svg`
  fill: currentColor;
  position: absolute;
  top: 42px;
  right: 20px;
  cursor: pointer;
`;

export const NavListMobile = styled.nav`
  display: flex;
  flex-direction: column;
  margin-top: 60px;
`;

export const ContactListMobile = styled.ul`
  display: block;
  position: fixed;
  bottom: 30px;

  padding: 0;
  list-style: none;
`;

export const ContactListTel = styled.li`
  &:not(:last-child) {
    margin-bottom: 10px;
  }
`;

